import clsx from "clsx";
import { Icon, type IconProps } from "@/ui/icon/Icon";

export interface CheckboxIconProps extends Omit<IconProps, "name"> {
  active?: boolean;
  highlight?: boolean;
  disabled?: boolean;
}

export const CheckboxIcon: React.FC<CheckboxIconProps> = ({
  active,
  highlight,
  disabled,
  className,
  ...props
}) => {
  return (
    <Icon
      className={clsx(
        "checkbox-icon",
        [
          active === true && "active",
          highlight === true && "highlight",
          disabled === true && "disabled",
        ],
        className,
      )}
      name="check_box_24px"
      {...props}
    />
  );
};
